import { NgModule } from '@angular/core';
import { SnapAngularLibComponent } from './snap-angular-lib.component';

@NgModule({
  declarations: [SnapAngularLibComponent],
  imports: [
  ],
  exports: [SnapAngularLibComponent]
})
export class SnapAngularLibModule { }
